module.exports = __webpack_public_path__ + "static/media/car2.73f0c723.png";